import { Floor } from "@pdfking/math"
import type { PageNumber } from "@pdfking/renderer-api"
import { GroupBy, SortBy, Values } from "@pdfking/tfunc"

import type { NumberedPage } from "#internal"

import { PathKey } from "../../../common/layout/PathKey"

/** The pages four by four as a blueline reads them: the two sides of a leaf
 * and the two of its partner across the spine, lines in page order. */
export const BluelinePageNumbers = (pages: NumberedPage[]): PageNumber[][] => {
  if (!pages.some(p => (p.meta.page_total || 0) >= 4)) return []

  const groups = GroupBy(pages, page =>
    PathKey([...page.group, Floor((page.meta.page_index + 1) / 2)])
  )

  const lines = Values(groups).filter(line => line.length === 4)
  return SortBy(lines, line => line[0]!.page_number).map(line => line.map(page => page.page_number))
}
